import * as React from 'react'
import { differenceInCalendarDays, format } from 'date-fns'

interface ArtifactTimestampProps {
  date: Date | string
  className?: string
}

export function ArtifactTimestamp({ date, className }: ArtifactTimestampProps) {
  const today = new Date()
  const realDate = React.useMemo(() => {
    if (typeof date === 'string') {
      return new Date(date)
    }
    return date
  }, [date])
  const daysAgo = differenceInCalendarDays(today, realDate)

  const formatted = daysAgo <= 7 ? format(realDate, "EEEE 'at' h:mmaaa") : format(realDate, "MMMM do 'at' h:mmaaa")
  return <span className={className}>{formatted}</span>
}
